<template>
    <div class="access-box">
        <div class="btn-box" @click="createDevice">
                <i class="iconfont icon-jiahao"></i>
                添加设备
        </div>
        <div class="device-box">
            <div class="device-item" v-for="(item,index) in accessList" :class="{active:currentItem.id==item.id}" @click="changeItem(item)" :key="index">
                <div>{{ item.name }}</div>
                <div>
                    <span>{{ item.code }}</span>
                    <span>{{ item.address }}</span>
                </div>
                <div class="bottom-person">
                    <div>
                        <span>进场人次：</span>
                        <span>{{ item.in }}</span>
                    </div>
                    <div>
                        <span>离场人次：</span>
                        <span>{{ item.out }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-box-content">
            <div class="top-box">
                <span>{{currentItem.name}}</span>
                <div class="btn-box">导出</div>
            </div>
            <div class="box-content">
                <Table
                    :totalSize="pages.total"
                    :pagination="true"
                    :serialNumber="true"
                    :operationWidth="350"
                    :currentPage="pages.current"
                    @changeCurrentPage="changeCurrentPage"
                    @changePageSize="changePageSize"
                    :pageSize="pages.size"
                    navHeight=40
                    ref="table"
                    :tableData="tableData"
                    :tableKey="tableKey"
                >
                <template slot="operation" slot-scope="data">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                        <i class="iconfont icon-shanchu" @click="del(data.data.row)"></i>
                    </el-tooltip> 
                 </template>
                </Table>
            </div>
        </div>
        <create-device ref="create_device"></create-device>
    </div>
</template>

<script>
import CreateDevice from './accessMag/CreateDevice.vue'
    export default {
  components: { CreateDevice },
        data(){
            return {
                /**门禁设备数据 */
                accessList:[
                    {
                        name:'门禁设备1',
                        code:'ZDZXKQSB',
                        address:'实训室正门',
                        in:20,
                        out:10,
                        id:'1'
                    },
                    {
                        name:'门禁设备2',
                        code:'ZDZXKQSB',
                        address:'实训室正门',
                        in:100,
                        out:30,
                        id:'2'
                    },
                    {
                        name:'门禁设备3',
                        code:'ZDZXKQSB',
                        address:'实训室正门',
                        in:60,
                        out:30,
                        id:'3'
                    },
                ],
                /**列表数据 */
                tableData:[
                    {
                        name:'张三',
                        class:'智能建造02级1班',
                        status:'入',
                        time:'2025-03-11 10:21:15',
                        id:'1'
                    },
                    {
                        name:'李四',
                        class:'智能建造02级1班',
                        status:'入',
                        time:'2025-03-11 10:21:15',
                        id:'2'
                    },
                    {
                        name:'王五',
                        class:'智能建造02级1班',
                        status:'出',
                        time:'2025-03-11 10:21:15',
                        id:'3'
                    },
                ],
                pages:{
                    current:1,
                    size:10,
                    total:3
                },
                tableKey:[
                {name: '人员', value: 'name'},
                {name: '实训班级', value: 'class'},
                {name: '出/入', value: 'status'},
                {name: '时间', value: 'time'},
                {name: '操作', value: 'operation',slot:'operation'},
                ],
                currentItem:{
                        name:'门禁设备1',
                        code:'ZDZXKQSB',
                        address:'实训室正门',
                        in:20,
                        out:10,
                        id:'1'
                    },
            }
        },
        methods:{
            changeCurrentPage(){

            },
            changePageSize(){

            },
            /**切换设备 */
            changeItem(item){
                this.currentItem=item;
            },
            createDevice(){
                let dialog=this.$refs.create_device;
                if(dialog){
                    dialog.dialogVisible=true;
                }
            },
            del(data){

            }
        }
    }
</script>

<style lang="less" scoped>
.access-box{
    height: 100%;
    color: #334681;
}
.btn-box{
    width: 14rem;
    height: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    color: #ffffff;
    transition: all 0.3s;
    cursor: pointer;
    background-color: var(--blue);
    i{
        margin-right: 3px;
        font-size: 2rem;
    }
}
.bottom-person{
    display: flex;
}
.device-box{
    display: flex;
    margin-top: 2rem;
    overflow: auto;
    .device-item{
        width: calc((100% - 8rem)/5);
        min-width: 30rem;
        height: 13rem;
        padding: 1.5rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-radius: 1rem;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        background-color: #ffffff;
        cursor: pointer;
        &> :nth-child(n){
            display: flex;
            justify-content: space-between;
        }
    }
    &> :nth-child(n){
        margin-left: 2rem;
    }
    &> :nth-child(1){
        margin-left: 0;
    }
}
.table-box-content{
    margin-top: 2rem;
    height: calc(100% - 21rem);
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    padding: 2rem;
    .top-box{
        display: flex;
        align-items: center;
        &> :nth-child(1){
            margin-right: 2rem;
            font-size: 16px;
            font-weight: 700;
        }
    }
    .box-content{
        height: calc(100% - 7rem);
        margin-top: 2rem;
    }
}
.active{
    background-color: var(--blue) !important;
    color: #ffffff !important;
}
.icon-shanchu{
    color: var(--blue);
    cursor: pointer;
}
</style>